/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { MissingReceiptsDto, TransactionFilterRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiMissingReceiptsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-missing-receipts-controller
   * @name NotifyAboutMissingReceipts
   * @request POST:/api/v1/missing-receipts/notify
   */
  notifyAboutMissingReceipts = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/missing-receipts/notify`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static notifyAboutMissingReceiptsPath = '/v1/missing-receipts/notify'
  static notifyAboutMissingReceiptsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-missing-receipts-controller
   * @name GetMissingReceiptsGroupedByUser
   * @request GET:/api/v1/missing-receipts/grouped-by-user
   * @deprecated
   */
  getMissingReceiptsGroupedByUser = (params: RequestParams = {}) =>
    this.http.request<MissingReceiptsDto[], any>({
      path: `/v1/missing-receipts/grouped-by-user`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMissingReceiptsGroupedByUserPath = '/v1/missing-receipts/grouped-by-user'
  static getMissingReceiptsGroupedByUserMethod = 'GET'
  /**
   * No description
   *
   * @tags api-missing-receipts-controller
   * @name GetMissingReceiptsGroupedByUserWithFilterRequest
   * @request POST:/api/v1/missing-receipts/grouped-by-user
   * @deprecated
   */
  getMissingReceiptsGroupedByUserWithFilterRequest = (
    data: TransactionFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<MissingReceiptsDto[], any>({
      path: `/v1/missing-receipts/grouped-by-user`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getMissingReceiptsGroupedByUserWithFilterRequestPath =
    '/v1/missing-receipts/grouped-by-user'
  static getMissingReceiptsGroupedByUserWithFilterRequestMethod = 'POST'
}
